// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorBoundary_root__dbpH4","error":"ErrorBoundary_error__e4mer"};